import { useEffect, useState } from "react";
import EpressImage from "../../Assets/Images/epress-image.png";
import {
  capitalizeFirstLetter,
  getAge,
} from "../Helpers/Utilities/Common";

export default function PrintEpress(props) {
  const [details, setDetails] = useState([]);

  useEffect(() => {
    setDetails(props.data);
  }, [props?.data]);

  const getFullName = (patient) => {
    if (!patient) return "";
    const { last_name, first_name, middle_name, suffix } = patient;

    // Only include non-empty values and add proper spacing/format
    return [
      last_name,
      ",",
      first_name,
      middle_name && middle_name.trim() && middle_name.toUpperCase() !== "N/A" ? ` ${middle_name}` : "",
      suffix ? ` ${suffix}` : "",
    ]
      .filter(Boolean)
      .join(" ")
      .replace(/\s+,/g, ",") // clean up cases like " ,"
      .trim();
  };

  return (
    <div className="form-page">
      <div id="printablediv2" className="display-none">
        <div id="page-1" className="bir-form">
          <img
            src={EpressImage}
            alt="Epress"
            className="epress-img mt-1"
          />
          <div className="ekas-form-details-cont">
            <p className="epress-patient-hci-name">
              {details?.branch_detail?.branch_name
                ? details?.branch_detail?.branch_name
                : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="epress-patient-accred-no">
              {details?.branch_detail?.accred_no
                ? details?.branch_detail?.accred_no
                : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="epress-patient-transaction-no">
              {details?.assessment?.id ? details?.assessment?.id : ""}
            </p>
          </div>
          {details?.patient?.phic_membership_type === "member" && (
            <>
              <div className="ekas-form-details-cont">
                <p className="epress-patient-pin">
                  {details?.patient?.phic_pin ? details?.patient?.phic_pin : ""}
                </p>
              </div>
            </>
          )}
          {details?.patient?.phic_membership_type === "dependent" && (
            <>
              <div className="ekas-form-details-cont">
                <p className="epress-patient-pin">
                  {details?.patient?.phic_dependent_pin
                    ? details?.patient?.phic_dependent_pin
                    : ""}
                </p>
              </div>
            </>
          )}
          <div className="ekas-form-details-cont">
            <p className="epress-patient-member-category">
              {details?.patient?.phic_membership_type
                ? capitalizeFirstLetter(details?.patient?.phic_membership_type)
                : ""}
            </p>
          </div>
          {details?.patient?.phic_membership_type === "member" && (
            <>
              <div className="ekas-form-details-cont">
                <p className="epress-patient-member-type">✔</p>
              </div>
            </>
          )}
          {details?.patient?.phic_membership_type === "dependent" && (
            <>
              <div className="ekas-form-details-cont">
                <p className="epress-patient-dependent-type">✔</p>
              </div>
            </>
          )}
          <div className="ekas-form-details-cont">
            <p className="epress-patient-name">
              {getFullName(details?.patient)}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="epress-patient-age">
              {details?.patient?.birthdate
                ? getAge(details?.patient?.birthdate)
                : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="epress-patient-contact-no">
              {details?.patient?.contact_no ? details?.patient?.contact_no : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <div className="epress-patient-therapeutics">
              {Array.isArray(details?.therapeutics) &&
                details.therapeutics.length > 0 &&
                details.therapeutics.map((item, index) => (
                  <div key={index} className="therapeutic-block">
                    <div className="therapeutic-item">
                      <span>
                        {index + 1}.
                        <span className="ms-2">{item.formatted_name}</span>
                      </span>
                      <span className="therapeutic-quantity">
                        # {item.quantity}
                      </span>
                    </div>

                    {item?.instruction && (
                      <div className="therapeutic-instruction">
                        Sig: {item.instruction}
                      </div>
                    )}
                    {item?.note && (
                      <div className="therapeutic-note">Note: {item.note}</div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div className="ekas-form-details-cont">
            <p className="epress-footer-doc-name">
              {details?.assessment?.doc_name ? details?.assessment?.doc_name : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="epress-footer-prc">
              {details?.assessment?.license_no
                ? details?.assessment?.license_no
                : details?.assessment?.prc_no
                ? details?.assessment?.prc_no
                : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="epress-footer-ptr">
              {details?.assessment?.ptr_no ? details?.assessment?.ptr_no : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="epress-footer-s2">
              {details?.assessment?.s2_no ? details?.assessment?.s2_no : ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
